import {ChangeDetectionStrategy, Component} from '@angular/core';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [],
    template: ``,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {
    constructor() {
        window.location.href = `${environment.reactOnlineUrl}/resetpassword`;
    }
}
